import * as t from "io-ts";

const V1DomainsC = t.union([
    t.literal("expertiseAndResources"),
    t.literal("learningOrientation"),
    t.literal("purpose"),
    t.literal("relationships"),
    t.literal("wellBeing"),
]);

const V1ExpertiseAndResourcesC = t.union([
    t.literal("bestPracticeOrientation"),
    t.literal("classroomManagement"),
    t.literal("engagedLearning"),
    t.literal("qualifiedStaff"),
    t.literal("resourceConstraint"),
    t.literal("resourcePlanning"),
    t.literal("resources"),
    t.literal("responsivenessToSpecialNeeds"),
]);

const V1LearningOrientationC = t.union([
    t.literal("collaboration"),
    t.literal("cultureOfImprovement"),
    t.literal("dataDrivenImprovement"),
    t.literal("feedback"),
    t.literal("individualizedInstruction"),
    t.literal("outcomesFocus"),
    t.literal("professionalDevelopment"),
    t.literal("systemsThinking"),
]);

const V1PurposeC = t.union([
    t.literal("godsStory"),
    t.literal("holisticTeaching"),
    t.literal("integratedWorldView"),
    t.literal("partnership"),
    t.literal("questioning"),
    t.literal("responsibility"),
    t.literal("spiritualFormation"),
]);

const V1RelationshipsC = t.union([
    t.literal("caringEnvironment"),
    t.literal("christlikeTeachers"),
    t.literal("communityEngagement"),
    t.literal("insularCulture"),
    t.literal("leadershipInterdependence"),
    t.literal("mentoringStudents"),
    t.literal("parentRelationships"),
    t.literal("prosocialOrientation"),
    t.literal("supportiveLeadership"),
]);

const V1WellBeingC = t.union([t.literal("healthyLiving"), t.literal("resilience"), t.literal("stress")]);

const V1ConstructsC = t.union([
    t.literal("bestPracticeOrientation"),
    t.literal("caringEnvironment"),
    t.literal("christlikeTeachers"),
    t.literal("classroomManagement"),
    t.literal("collaboration"),
    t.literal("communityEngagement"),
    t.literal("cultureOfImprovement"),
    t.literal("dataDrivenImprovement"),
    t.literal("engagedLearning"),
    t.literal("feedback"),
    t.literal("godsStory"),
    t.literal("healthyLiving"),
    t.literal("holisticTeaching"),
    t.literal("individualizedInstruction"),
    t.literal("insularCulture"),
    t.literal("integratedWorldView"),
    t.literal("leadershipInterdependence"),
    t.literal("mentoringStudents"),
    t.literal("outcomesFocus"),
    t.literal("parentRelationships"),
    t.literal("partnership"),
    t.literal("professionalDevelopment"),
    t.literal("prosocialOrientation"),
    t.literal("qualifiedStaff"),
    t.literal("questioning"),
    t.literal("resilience"),
    t.literal("resourceConstraint"),
    t.literal("resourcePlanning"),
    t.literal("resources"),
    t.literal("responsibility"),
    t.literal("responsivenessToSpecialNeeds"),
    t.literal("spiritualFormation"),
    t.literal("stress"),
    t.literal("supportiveLeadership"),
    t.literal("systemsThinking"),
]);

const V1DomainConstructsC = t.type({
    domain: V1DomainsC,
    construct: V1ConstructsC,
});

const V1DataC = t.type({
    expertiseAndResources: t.type({
        bestPracticeOrientation: t.number,
        classroomManagement: t.number,
        engagedLearning: t.number,
        qualifiedStaff: t.number,
        resourceConstraint: t.number,
        resourcePlanning: t.number,
        resources: t.number,
        responsivenessToSpecialNeeds: t.number,
    }),
    learningOrientation: t.type({
        collaboration: t.number,
        cultureOfImprovement: t.number,
        dataDrivenImprovement: t.number,
        feedback: t.number,
        individualizedInstruction: t.number,
        outcomesFocus: t.number,
        professionalDevelopment: t.number,
        systemsThinking: t.number,
    }),
    purpose: t.intersection([
        t.type({
            godsStory: t.number,
            holisticTeaching: t.number,
            integratedWorldView: t.number,
            partnership: t.number,
            responsibility: t.number,
            spiritualFormation: t.number,
        }),
        t.partial({
            questioning: t.number,
        }),
    ]),
    relationships: t.type({
        caringEnvironment: t.number,
        christlikeTeachers: t.number,
        communityEngagement: t.number,
        insularCulture: t.number,
        leadershipInterdependence: t.number,
        mentoringStudents: t.number,
        parentRelationships: t.number,
        prosocialOrientation: t.number,
        supportiveLeadership: t.number,
    }),
    wellBeing: t.type({
        healthyLiving: t.number,
        resilience: t.number,
        stress: t.number,
    }),
});

const V1OpportunityC = t.intersection([
    t.type({
        title: t.string,
        prologue: t.string,
    }),
    t.partial({
        extra: t.string,
    }),
]);

const V1AreasOfImprovementC = t.type({
    expertiseAndResources: t.type({
        bestPracticeOrientation: V1OpportunityC,
        classroomManagement: V1OpportunityC,
        engagedLearning: V1OpportunityC,
        qualifiedStaff: V1OpportunityC,
        resourceConstraint: V1OpportunityC,
        resourcePlanning: V1OpportunityC,
        resources: V1OpportunityC,
        responsivenessToSpecialNeeds: V1OpportunityC,
    }),
    learningOrientation: t.type({
        collaboration: V1OpportunityC,
        cultureOfImprovement: V1OpportunityC,
        dataDrivenImprovement: V1OpportunityC,
        feedback: V1OpportunityC,
        individualizedInstruction: V1OpportunityC,
        outcomesFocus: V1OpportunityC,
        professionalDevelopment: V1OpportunityC,
        systemsThinking: V1OpportunityC,
    }),
    purpose: t.intersection([
        t.type({
            godsStory: V1OpportunityC,
            holisticTeaching: V1OpportunityC,
            integratedWorldView: V1OpportunityC,
            partnership: V1OpportunityC,
            responsibility: V1OpportunityC,
            spiritualFormation: V1OpportunityC,
        }),
        t.partial({
            questioning: V1OpportunityC,
        }),
    ]),
    relationships: t.type({
        caringEnvironment: V1OpportunityC,
        christlikeTeachers: V1OpportunityC,
        communityEngagement: V1OpportunityC,
        insularCulture: V1OpportunityC,
        leadershipInterdependence: V1OpportunityC,
        mentoringStudents: V1OpportunityC,
        parentRelationships: V1OpportunityC,
        prosocialOrientation: V1OpportunityC,
        supportiveLeadership: V1OpportunityC,
    }),
    wellBeing: t.type({
        healthyLiving: V1OpportunityC,
        resilience: V1OpportunityC,
        stress: V1OpportunityC,
    }),
});

export const V1ReportC = t.type({
    id: t.string,
    results: t.type({
        benchmarks: V1DataC,
        keyGrowthOpportunities: t.array(V1DomainConstructsC),
        meaningfulStrengths: t.array(V1DomainConstructsC),
        raw: V1DataC,
    }),
    version: t.literal("1"),
    year: t.string,
    type: t.string,
});

export type V1Domains = t.TypeOf<typeof V1DomainsC>;
export type V1ExpertiseAndResources = t.TypeOf<typeof V1ExpertiseAndResourcesC>;
export type V1LearningOrientation = t.TypeOf<typeof V1LearningOrientationC>;
export type V1Purpose = t.TypeOf<typeof V1PurposeC>;
export type V1Relationships = t.TypeOf<typeof V1RelationshipsC>;
export type V1WellBeing = t.TypeOf<typeof V1WellBeingC>;
export type V1AreasOfImprovement = t.TypeOf<typeof V1AreasOfImprovementC>;

export type V1Report = t.TypeOf<typeof V1ReportC>;
export type FSCIBrandedV1Report = { tag: "v1_FSCI"; value: V1Report };
